import $ from "jquery";

const alertContent = '.alert-sidebar';
const alertContentMobile = '#alert-sidebar-mobile';
const alertContentDesktop = '#alert-sidebar-desktop';

const indexesContent = '.sidebar-indexes';
const indexesContentDesktop = '#indexes-sidebar-desktop';
const indexesContentMobile = '#indexes-sidebar-mobile';

const getScreenWidth = () => { return $(window).width() }
let width;
let breakpoint = 992;

const setMobileContent = () => {
    width = getScreenWidth();

  if (width < breakpoint) {
    $(alertContent).detach().appendTo(alertContentMobile)
    $(indexesContent).detach().appendTo(indexesContentMobile)
  } else {

    $(alertContent).detach().appendTo(alertContentDesktop)
    $(indexesContent).detach().appendTo(indexesContentDesktop)
  }
}

$(() => {
    $(window).on('load', () => setMobileContent())
        .on('resize', () => setMobileContent())
});
